package org.hs_soft.runmynesto.domain.util

import org.hs_soft.runmynesto.domain.repository.network_datasource.home.FetchIdTokenRepository
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class TokenProvider: KoinComponent {
    var token: String =""
        private set

    private val fetchIdTokenRepository: FetchIdTokenRepository by inject()

    suspend fun refreshToken() {
        val newToken = fetchIdTokenRepository.getIdToken()
        updateToken(newToken)
    }

    fun updateToken(newToken: String) {
        token = newToken
    }
}